
import { Col, Container, Row } from "react-bootstrap";
import homeLogo from "../../Assets/Arpit.jpg";
// import homeLogo from "../../Assets/Profile.jpg";
import About from "../About/About";
import Experience from "../Experience/Experience";
import Particle from "../Particle";
import Projects from "../Projects/Projects";
import ResumeNew from "../Resume/ResumeNew";


import {
  AiFillGithub,
  AiOutlineTwitter
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home() {
  
  return (

    
    <section >
      <Container fluid className="home-section" id="home" >
        <Particle />
        <Container className="home-content" >
          <Row >
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> ARPIT SHARMA</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <p className="purple">
                  I am a final-year 
                  <i> <b className="purple">Computer Science & Engineering </b></i> student at 
                  <i> <b className="purple">Pranveer Singh Institute of Technology</b></i>  with a strong understanding 
                  of computer science fundamentals, 
                  systematic problem-solving, Java and web technologies.
                  I look forward to exploring new <i> <b className="purple">opportunities </b></i> and <i> <b className="purple">collaborations.</b></i> 
              {/* I'm a  */}
              {/* <i> <b className="purple"> Full Stack Developer </b></i> 
              and
              <i><b className="purple">  Software Engineer </b> </i> 
              passionate about building clean, user-focused 
              <i><b className="purple"> web applications. </b> </i>
              I’ve gained practical experience through 
              <i><b className="purple">  projects </b> </i>and
              <i><b className="purple">   internships,</b> </i> and 
              <i><b className="purple"> I’m always open to new challenges and collaborations. </b> </i>  */}
              <br />
              
            </p>
              </div>
            </Col>
            

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "400px", borderRadius: "100%" }}
              />
            </Col>
            {/* <br  /> */}
            <Row >
              <Col md={12} className="home-about-social">
              <h3> Find me on </h3>
                <ul className="home-about-social-links">
                  <li className="social-icons">
                    <a
                      href="https://github.com/arpitsharma6074"
                      target="_blank"
                      rel="noreferrer"
                      className="icon-colour  home-social-icons"
                    >
                      <AiFillGithub />
                    </a>
                  </li>
                  <li className="social-icons">
                    <a
                      href="https://x.com/_ArpitSharma__"
                      target="_blank"
                      rel="noreferrer"
                      className="icon-colour  home-social-icons"
                    >
                      <AiOutlineTwitter />
                    </a>
                  </li>
                  <li className="social-icons">
                    <a
                      href="https://www.linkedin.com/in/arpitsharma6074/"
                      target="_blank"
                      rel="noreferrer"
                      className="icon-colour  home-social-icons"
                    >
                      <FaLinkedinIn />
                    </a>
                  </li>
                  {/* <li className="social-icons">
                    <a
                      href="https://www.instagram.com/its_me_arpitsharma"
                      target="_blank"
                      rel="noreferrer"
                      className="icon-colour home-social-icons"
                    >
                      <AiFillInstagram />
                    </a>
                  </li> */}
                </ul>
              </Col>
            </Row>
          </Row>
        </Container>
        <Container fluid className="contain no-bg" style={{ margin: "0px", padding:"0px"}}>
          <div id="about" className="about-section no-bg">
            <About />
          </div>
          <div id="experience" className="experience-section no-bg">
            <Experience />
          </div>
          <div id="projects" className="project-section no-bg">
            <Projects />
          </div>
          <div id="resume" className="resume-section no-bg">
            <ResumeNew />
          </div>
        </Container>
      
      </Container>
      
    </section>
  );
}


export default Home;